import { ArrowRight, BookOpenCheck, CheckCircle2, MessageSquareText, Search, Sparkles } from 'lucide-react'
import { useMemo, useState } from 'react'
import { Link } from 'react-router-dom'
import { openFeedbackDialog } from '../feedback-events.js'
import { LEARNING_RESOURCES, getLearnedResources } from '../student-learning-resources.js'

function StudentResourcesPage() {
  const [query, setQuery] = useState('')
  const learned = getLearnedResources()
  const resources = useMemo(() => {
    const needle = query.trim().toLowerCase()
    if (!needle) return LEARNING_RESOURCES
    return LEARNING_RESOURCES.filter((item) => (
      `${item.title} ${item.category} ${item.intro}`.toLowerCase().includes(needle)
    ))
  }, [query])

  return (
    <main className="page-container student-resource-page">
      <section className="student-resource-hero">
        <span><BookOpenCheck size={17} /> 学习资源中心</span>
        <h1>把路线、项目、竞赛和证书接到真实学习资源。</h1>
        <p>先用规则模板整理官方文档、免费视频、练习网站、开源项目、面试题和实战项目。不是博客，是可执行学习页。</p>
        <label className="student-resource-search">
          <Search size={17} />
          <input value={query} onChange={(event) => setQuery(event.target.value)} placeholder="搜索 Spring Boot、Redis、蓝桥杯、软考..." />
        </label>
      </section>

      <section className="student-resource-grid">
        {resources.length ? resources.map((item) => {
          const done = learned.includes(item.id)
          return (
            <Link className="student-resource-card" key={item.id} to={`/resource/${item.id}`}>
              <span>{item.category}</span>
              <h2>{item.title}</h2>
              <p>{item.intro}</p>
              <div>
                {done ? <small><CheckCircle2 size={14} /> 已学习</small> : <small><Sparkles size={14} /> 推荐学习</small>}
                <strong>查看资源 <ArrowRight size={15} /></strong>
              </div>
            </Link>
          )
        }) : (
          <article className="student-resource-card">
            <span>暂无结果</span>
            <h2>没有匹配的学习资源</h2>
            <p>换个关键词再试，或把你想要的资源方向提交反馈。</p>
            <div>
              <button type="button" className="secondary-button" onClick={() => setQuery('')}>清空搜索</button>
              <button type="button" className="secondary-button" onClick={() => openFeedbackDialog({ type: 'suggestion', content: `希望补充学习资源：${query}` })}>
                <MessageSquareText size={15} /> 提交反馈
              </button>
            </div>
          </article>
        )}
      </section>
    </main>
  )
}

export default StudentResourcesPage
